// extracted by mini-css-extract-plugin
export var closeButton = "_n8-1";
export var closeX = "_n8-3";
export var container = "_n8-0";
export var image = "_n8-2";